import { AddVoucherErrorV1 } from '@vista-digital/ocapi-client';
import { VoucherType } from '@vista-digital/ocapi-types/v1';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { voucherCredentialsValidator } from '../../../../utils/validators/voucher-credentials';
import { OrderDomainError } from '../../errors/order-domain-error';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsStandardOrder } from '../../utils/order-type-utils';
import { attemptToAddOrderTicketForVoucher } from '../tickets/attempt-to-add-order-ticket-for-voucher';
import { registerOrderAction } from '../utils/register-order-action';
import { mapAddVoucherErrorCodeToDomainErrorCode } from './utils/add-voucher-error-code-mapper';
import { storeOrderVoucher } from './utils/store-order-voucher';
/**
 * Adds a ticket voucher to the order
 */
export const addOrderTicketVoucherForShowtime = async (showtimeId, credentials, attemptToAutomaticallyAddTicket = true) => {
    const order = getOrder();
    assertIsStandardOrder(order, 'Cannot add ticket voucher');
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot add ticket voucher. Provided showtimeId is invalid.');
    }
    if (!voucherCredentialsValidator(credentials, logger.error, 'credentials')) {
        throw new Error('Cannot add ticket voucher. Provider voucher credentials are invalid.');
    }
    const deregisterAction = registerOrderAction('add-order-ticket-voucher-for-showtime');
    let response;
    try {
        response = await ocapiClient.instance.v1.orders.vouchers.add(order.id, {
            type: VoucherType.Ticket,
            showtimeId,
            credentials
        });
    }
    catch (error) {
        if (error instanceof AddVoucherErrorV1) {
            const errorCode = mapAddVoucherErrorCodeToDomainErrorCode(error.errorCode);
            throw new OrderDomainError(errorCode, error.message);
        }
        throw error;
    }
    finally {
        deregisterAction();
    }
    storeOrderVoucher(response);
    if (attemptToAutomaticallyAddTicket) {
        attemptToAddOrderTicketForVoucher(showtimeId, response.voucher);
    }
    return response.voucher;
};
